import { render, staticRenderFns } from "./templateSetting.vue?vue&type=template&id=2b2f7a3a&scoped=true&"
import script from "./templateSetting.vue?vue&type=script&lang=js&"
export * from "./templateSetting.vue?vue&type=script&lang=js&"
import style0 from "./templateSetting.vue?vue&type=style&index=0&id=2b2f7a3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2f7a3a",
  null
  
)

export default component.exports